import { ChangeEvent, ReactElement, useState } from 'react'
import { defineMessages, useIntl, FormattedMessage } from 'react-intl'
import { Formik } from 'formik'
import { isEmpty, keys } from 'lodash'

import { Column } from '@10xLabs/react-web/components/Column'
import { Row } from '@10xLabs/react-web/components/Row'
import { FilterToggle, FilterWrapper, FiltersSubmit, FiltersWrapper, TagsWrapper } from 'components/Filters'
import { Select } from 'components/v2/Select'
import { Tag } from 'components/v2/Tag'
import { IFaresFilters, IFaresFiltersProps } from 'features/FareFamilies/views/Index/FaresFilters/types'
import { EStatus } from 'features/FareFamilies/components/Status/constants'
import { statusMessages } from 'features/FareFamilies/components/Status/messages'
import { safeFormatMessage } from 'utils/intl'

const STATUS_LIST = [EStatus.Active, EStatus.Inactive]

const messages = defineMessages({
  selectStatus: {
    id: 'faresFamilies.fares.filters.selectStatus',
    defaultMessage: 'Select status'
  }
})

const defaultValues: IFaresFilters = {
  status: ''
}

export const FaresFilters = ({ filters = {}, onFiltersChange }: IFaresFiltersProps): ReactElement => {
  const intl = useIntl()
  const [isShowingFilters, showFilters] = useState(false)

  const toggleFilters = (): void => {
    showFilters(!isShowingFilters)
  }

  const filterFares = (values: IFaresFilters): void => {
    onFiltersChange(values)
  }

  const initialValues: IFaresFilters = {
    status: filters.status || defaultValues.status
  }

  return (
    <Formik initialValues={initialValues} onSubmit={filterFares} enableReinitialize>
      {(props): ReactElement => {
        const { handleSubmit, setFieldValue, values, handleChange } = props

        const handleFilterDelete = (id: keyof IFaresFilters): void => {
          setFieldValue(id, defaultValues[id])
          filterFares({
            ...values,
            [id]: defaultValues[id]
          })
        }

        const handleSelectChange = (event: ChangeEvent<HTMLSelectElement>): TSFixMe => {
          const {
            target: { id, value }
          } = event

          handleChange(event)

          filterFares({
            ...values,
            [id]: value
          })
        }

        return (
          <form onSubmit={handleSubmit}>
            <div>
              <FilterWrapper>
                <FilterToggle onClick={toggleFilters} />
                <TagsWrapper>
                  {keys(filters).map((filterKey): ReactElement | null => {
                    let label, value
                    const filterValue = filters[filterKey]
                    const hasValue = !isEmpty(filterValue)

                    if (!hasValue) return null

                    switch (filterKey) {
                      case 'status':
                        label = <FormattedMessage id="dictionary.status" defaultMessage="Status" />
                        value = safeFormatMessage({ intl, messages: statusMessages, key: filterValue })
                        break
                    }

                    return (
                      <Tag key={filterKey} onDelete={handleFilterDelete.bind(this, filterKey as keyof IFaresFilters)}>
                        {label}: {value}
                      </Tag>
                    )
                  })}
                </TagsWrapper>
              </FilterWrapper>
              <FiltersWrapper isShowingFilters={isShowingFilters} noBorder noPadding>
                <Row>
                  <Column width="50%">
                    <Select
                      id="status"
                      value={values.status}
                      onChange={handleSelectChange}
                      label={<FormattedMessage id="dictionary.status" defaultMessage="Status" />}
                    >
                      <option value="">{intl.formatMessage(messages.selectStatus)}</option>

                      {STATUS_LIST.map((status): TSFixMe => {
                        return (
                          <option value={status} key={status}>
                            {safeFormatMessage({ intl, messages: statusMessages, key: status })}
                          </option>
                        )
                      })}
                    </Select>
                  </Column>
                </Row>
              </FiltersWrapper>
            </div>
            <FiltersSubmit />
          </form>
        )
      }}
    </Formik>
  )
}
